import type { ReactNode } from "react";
import classNames from "classnames";
import IconButton from "@/components/IconButton";

export type ModalHeaderConfig = {
  title: ReactNode;
  onBack?: () => void;
  action?: ReactNode;
  disableClose?: boolean;
};

type ModalHeaderProps = ModalHeaderConfig & {
  slot?: string;
  onClose?: () => void;
  className?: string;
  titleClassName?: string;
  backButtonClassName?: string;
  closeButtonClassName?: string;
};

export default function ModalHeader({
  title,
  onBack,
  action,
  slot,
  onClose,
  disableClose = false,
  className,
  titleClassName,
  backButtonClassName,
  closeButtonClassName
}: ModalHeaderProps) {
  const trailingAction =
    action ??
    (!disableClose && onClose ? (
      <IconButton name="close" ariaLabel="close" onClick={onClose} className={closeButtonClassName} />
    ) : null);

  return (
    <div slot={slot} className={classNames("flex items-center justify-between gap-4", className)}>
      <div className="flex min-w-0 flex-1 items-center">
        {onBack && <IconButton name="arrow_back" ariaLabel="back" onClick={onBack} className={backButtonClassName} />}
        <div className={classNames("min-w-0 flex-1", titleClassName)}>{title}</div>
      </div>
      {trailingAction}
    </div>
  );
}
